
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./ReconSumumaryReport.module.css"
import plus from "../../../Assets/plus.svg"
import ReportBackground from "../../../Assets/report.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import HeaderNav from "../../Reconciliation/ReconciliationNav/ReconciliationNav";







const ReconSummaryReport = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [document, setDocument] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [bankName, setBankName] = useState('');
  const [bankId, setBankId] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const bankName = await localStorage.getItem('bankName');
      const bankId = await localStorage.getItem('bankID');

      if (value !== null) {
        setBearer(value);
      }
      if (bankName !== null) {
        setBankName(bankName);
      }
      if (bankId !== null) {
        setBankId(bankId);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };







  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  console.log(bankId, "NEWWW");

  const fetchAccounts = async () => {
    setSavingsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/reconciliation-summary-province-only`, {
        params: {
          gl_code: bankId || "",
          date: selectedDate,
          // end_date: selectedEndDate,
          // continent_id: selectedContinent || "",
          // region_id: selectedRegion || "",
          // province_id: selectedProvince || ""
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
 const result = response.data.data;
      setDocument(result);
    

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/');
      } else {
        console.log(error);
        setAccounts([]);   // ✅ also clear here on error
        setNoData(true);
      }
    } finally {
      setSavingsLoading(false);
    }
  };





  const filteredAccounts = accounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.details?.toLowerCase().includes(term) ||
      item.cheque_number?.toLowerCase().includes(term) ||
      item.transaction_date?.toLowerCase().includes(term)
    );
  });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash-and-bank`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);





  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers });

      // console.log(response);
      const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSubContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (accounts) {
      const debitTotal = accounts?.reduce((total, item) => total + parseFloat(item.debit), 0);
      const creditTotal = accounts?.reduce((total, item) => total + parseFloat(item.credit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

  const tableRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  const report = document; // or better: const report = reportData;

const toArray = (src) => {
  if (!src) return [];
  if (Array.isArray(src)) return src;
  if (typeof src === "object") return Object.values(src);
  return []; // anything else (string/number/etc.)
};

// Optional: safe numeric parser (handles "1,234.56" strings too)
const toNumber = (v) => {
  if (v == null) return 0;
  const n = Number(String(v).replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
};

const ocis = toArray(report?.OCIS);
const ocic = toArray(report?.OCIC);
const odis = toArray(report?.ODIS);
const odic = toArray(report?.ODIC);

   const totalOCIS = ocis.reduce((acc, item) => acc + toNumber(item.amount), 0);
const totalOCIC = ocic.reduce((acc, item) => acc + toNumber(item.amount), 0);
const totalODIS = odis.reduce((acc, item) => acc + toNumber(item.amount), 0);
const totalODIC = odic.reduce((acc, item) => acc + toNumber(item.amount), 0);


// Calculate the combined total
const combinedTotal = (totalOCIC + totalOCIS).toLocaleString(undefined, { 
  minimumFractionDigits: 2, 
  maximumFractionDigits: 2 
});

const combinedTotalODICS = (totalODIC + totalODIS).toLocaleString(undefined, { 
  minimumFractionDigits: 2, 
  maximumFractionDigits: 2 
});

const COB = parseFloat(document?.COB) || 0;


const result = COB + (parseFloat(combinedTotal.replace(/,/g, '')) - (parseFloat(combinedTotalODICS.replace(/,/g, ''))));

// Format the result to two decimal places with commas
const formattedResult = result.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});




  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Reconciliation Summary Report</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Bank:</label>
                <input
                  className="form-control"
                  type="text"
                  // onChange={handleDateChange}
                  value={bankName}
                  style={{ fontSize: 14 }}
                  // min={minDate}
                  // max={maxDate}
                  disabled
                />
                {/* <Select
                  onChange={handleBank}
                  options={allAccounts}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200, // ✅ fixed width
                      fontSize: 12, // applies to the wrapper
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12, // ✅ font size inside control
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12, // ✅ selected value text
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12, // ✅ dropdown option text
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12, // ✅ font size in menu
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                /> */}

              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{ fontSize: 14 }}
                  // min={minDate}
                  // max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                {/* <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  min={minDate}
                  style={{ fontSize: 14 }}
                  max={maxDate}
                  required
                /> */}
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}

          </div>


        </div>
        <div style={{ marginTop: 24 }} />
        <div style={{display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

        }}>

  <div className={classes.tableContainer}>
  {document.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        fontSize: "18px",
        color: "#374151",
      }}
    >
      <p>No data to display</p>
    </div>
  ) : (
    <>
    <div className={classes.page}>
      <div className={classes.sideTools}>
        {document.length > 0 && (
          <div className={classes.filterIcons}>
            <img
              src={MailLogo}
              alt="icon1"
              className={classes.iconBtns}
              onClick={() => console.log("icon1")}
            />
            <img
              onClick={() => handlePrint()}
              src={PrintLogo}
              alt="icon2"
              className={classes.iconBtns}
            />
            <img
              src={DownloadLogo}
              alt="icon3"
              className={classes.iconBtns}
              onClick={() => console.log("icon3")}
            />
          </div>
        )}
      </div>

      <div className={classes.cntrTable}>
        <h1 className={classes.cntrTxt}>
          The Redeemed Christian Church Of God
        </h1>
        <p className={classes.cntrTx122}>
          Reconciliation Summary Report as at {document?.date}
        </p>
        <p className={classes.cntrTx122}>
          {province === "undefined" ? admin : province}
        </p>
      </div>

      <div className={classes.details}>
        <div className={classes.row}>
          <span className={classes.region}>
            RECONCILIATION OF: {document?.account?.gl_name.toUpperCase()}
          </span>
          {/* <span className={classes.region}>
            PROVINCE: {province === "undefined" ? admin : province}
          </span> */}
          <span className={classes.region}>CURRENCY: NGN</span>
        </div>
        {/* <div className={classes.rowB}>
          <span className={classes.region}>
            RECONCILIATION OF: {document?.account?.gl_name.toUpperCase()}
          </span>
        </div> */}
      </div>

      {/* Summary table */}
<table
  className={classes.tableData}
  style={{
    border: "none",
    borderCollapse: "collapse",
    width: "100%",
  }}
>
  <tbody>
    <tr className={classes.openTop} style={{ border: "none" }}>
      <td
        className={classes.ledgerBal}
        style={{ border: "none", textAlign: "left", }}
      >
        Ledger Opening Balance:
      </td>
      <td className={classes.td} style={{ border: "none" }}></td>
      <td
        className={classes.ledgerAmount}
        style={{ border: "none", textAlign: "right", }}
      >
        {document?.COB.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
    </tr>

    <tr style={{ border: "none", marginTop: "2rem" }}>
      <td
        colSpan={2}
        className={classes.addT}
        style={{ border: "none", textAlign: "left" }}
      >
        ADD :
      </td>
      <td style={{ border: "none" }}></td>
    </tr>

    <tr style={{ border: "none" }}>
      <td
        className={classes.ledgerOt}
        style={{ border: "none", textAlign: "left", }}
      >
        Outstanding Credits in LEDGER:
      </td>
      <td
        className={classes.amount}
        style={{ border: "none", textAlign: "right", }}
      >
        {document?.OCIC?.reduce(
          (acc, item) => acc + (parseFloat(item.amount) || 0),
          0
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
      <td style={{ border: "none" }}></td>
    </tr>

    <tr style={{ border: "none" }}>
      <td
        className={classes.ledgerOtC}
        style={{ border: "none", textAlign: "left",  }}
      >
        Outstanding Credits in STATEMENT:
      </td>
      <td
        className={classes.amountC}
        style={{ border: "none", textAlign: "right",  }}
      >
        {Object.values(document?.OCIS || {})
          .reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0)
          .toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
      </td>
      <td
        className={classes.totalC}
        style={{ border: "none", textAlign: "right", padding: "6px 8px" }}
      >
        {combinedTotal}
      </td>
    </tr>
<div style={{marginTop: '2rem'}}/>
    <tr style={{ border: "none", marginTop: "2rem" }}>
      <td
        colSpan={2}
        className={classes.addT}
        style={{ border: "none", textAlign: "left" }}
      >
        LESS:
      </td>
      <td style={{ border: "none" }}></td>
    </tr>

    <tr style={{ border: "none" }}>
      <td
        className={classes.ledgerOt}
        style={{ border: "none", textAlign: "left", }}
      >
        Outstanding Debits in LEDGER:
      </td>
      <td
        className={classes.amount}
        style={{ border: "none", textAlign: "right", }}
      >
        {document?.ODIC?.reduce(
          (acc, item) => acc + (parseFloat(item.amount) || 0),
          0
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
      <td style={{ border: "none" }}></td>
    </tr>

    <tr style={{ border: "none" }}>
      <td
        className={classes.ledgerOtC}
        style={{ border: "none", textAlign: "left", padding: "6px 8px" }}
      >
        Outstanding Debits in STATEMENT:
      </td>
      <td
        className={classes.amountC}
        style={{ border: "none", textAlign: "right",  }}
      >
        {Object.values(document?.ODIS || {})
          .reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0)
          .toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
      </td>
      <td
        className={classes.totalC}
        style={{ border: "none", textAlign: "right",  }}
      >
        {combinedTotalODICS}
      </td>
    </tr>
<div style={{marginTop: '2rem'}}/>
    <tr style={{ border: "none" }}>
      <td
        className={classes.addStatment}
        style={{ border: "none", textAlign: "left",  }}
      >
        Statement Balance:
      </td>
      <td className={classes.td} style={{ border: "none" }}></td>
      <td
        className={classes.ledgerAmount}
        style={{ border: "none", textAlign: "right",  }}
      >
        {document?.SOB.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
    </tr>

    <tr style={{ border: "none" }}>
      <td
        className={classes.addStatment}
        style={{ border: "none", textAlign: "left", marginTop: '2rem' }}
      >
        DIFFERENCE:
      </td>
      <td className={classes.td} style={{ border: "none" }}></td>
      <td
        className={classes.ledgerAmount}
        style={{ border: "none", textAlign: "right",  }}
      >
        {formattedResult}
      </td>
    </tr>
  </tbody>
</table>
<div style={{marginTop: '2rem'}}/>
{/* Footer signatures */}
<div className={classes.footer}>
  <div className={classes.rowFooter}>
    <span className={classes.addStatment}>PREPARED BY:</span>
    <span className={classes.addT}>Date:</span>
    <span></span>
  </div>
  <div className={classes.rowFooter}>
    <span className={classes.addStatment}>CHECKED BY:</span>
    <span className={classes.addT}>Date:</span>
    <span></span>
  </div>
  <div className={classes.rowFooter}>
    <span className={classes.addStatment}>APPROVED BY:</span>
    <span className={classes.addT}>Date:</span>
    <span></span>
  </div>
</div>
</div>

<div className={classes.pageGap} />
{/* Detailed sections */}
<div className={classes.redeemTops}>
  <div className={`${classes.page} ${classes.pageBreak}`}>
    {/* Outstanding Debits in Ledger */}
    <div className={classes.detailsB}>
      <div className={classes.row}>
        <span className={classes.regions}>Outstanding Debits in Ledger</span>
      </div>
      <div className={classes.mainTable}>
        <div className="table-responsive">
          <table className="table display table-bordered table-hover bg-white m-0 card-table">
            <thead>
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: 0, fontSize: 14, textAlign: "left" }}>Post Date</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "left" }}>Val Date</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "left" }}>Details</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "right" }}>Amount</th>
                <th style={{ width: 0, fontSize: 14 }}>Remark</th>
              </tr>
            </thead>
            <tbody>
              {document?.ODIC?.map((item, index) => (
                <tr key={index}>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.post_date}</td>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.val_date}</td>
                  <td style={{ fontSize: 14, width: 500, textAlign: "left" }}>{item.description}</td>
                  <td style={{ fontSize: 14, textAlign: "right" }}>
                    {parseFloat(item.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td style={{ fontSize: 14 }}>{item.remark}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Outstanding Credits in Ledger */}
    <div className={classes.detailsB}>
      <div className={classes.row}>
        <span className={classes.regions}>Outstanding Credits in Ledger</span>
      </div>
      <div className={classes.mainTable}>
        <div className="table-responsive">
          <table className="table display table-bordered table-hover bg-white m-0 card-table">
            <thead>
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: 0, fontSize: 14 }}>Post Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Val Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Details</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "right" }}>Amount</th>
                <th style={{ width: 0, fontSize: 14 }}>Remark</th>
              </tr>
            </thead>
            <tbody style={{ whiteSpace: "nowrap" }}>
              {document?.OCIC?.map((item, index) => (
                <tr key={index}>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.post_date}</td>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.val_date}</td>
                  <td style={{ fontSize: 14, width: 500, textAlign: "left" }}>{item.description}</td>
                  <td style={{ fontSize: 14, textAlign: "right" }}>
                    {parseFloat(item.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td style={{ fontSize: 14 }}>{item.remark}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Outstanding Debits in Statement */}
    <div className={classes.detailsB}>
      <div className={classes.row}>
        <span className={classes.regions}>Outstanding Debits in Statement</span>
      </div>
      <div className={classes.mainTable}>
        <div className="table-responsive">
          <table className="table display table-bordered table-hover bg-white m-0 card-table">
            <thead>
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: 0, fontSize: 14 }}>Post Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Val Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Details</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "right" }}>Amount</th>
                <th style={{ width: 0, fontSize: 14 }}>Remark</th>
              </tr>
            </thead>
            <tbody style={{ whiteSpace: "nowrap" }}>
              {Object.values(document?.ODIS || {}).map((item, index) => (
                <tr key={index}>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.post_date}</td>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.val_date}</td>
                  <td style={{ fontSize: 14, width: 500, textAlign: "left" }}>{item.description}</td>
                  <td style={{ fontSize: 14, textAlign: "right" }}>
                    {parseFloat(item.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td style={{ fontSize: 14 }}>{item.remark}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Outstanding Credits in Statement */}
    <div className={classes.detailsB}>
      <div className={classes.row}>
        <span className={classes.regions}>Outstanding Credits in Statement</span>
      </div>
      <div className={classes.mainTable}>
        <div className="table-responsive">
          <table className="table display table-bordered table-hover bg-white m-0 card-table">
            <thead>
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: 0, fontSize: 14 }}>Post Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Val Date</th>
                <th style={{ width: 0, fontSize: 14 }}>Details</th>
                <th style={{ width: 0, fontSize: 14, textAlign: "right" }}>Amount</th>
                <th style={{ width: 0, fontSize: 14 }}>Remark</th>
              </tr>
            </thead>
            <tbody style={{ whiteSpace: "nowrap" }}>
              {Object.values(document?.OCIS || {}).map((item, index) => (
                <tr key={index}>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.post_date}</td>
                  <td style={{ fontSize: 14, whiteSpace: "nowrap", textAlign: "left" }}>{item.val_date}</td>
                  <td style={{ fontSize: 14, width: 500, textAlign: "left" }}>{item.description}</td>
                  <td style={{ fontSize: 14, textAlign: "right" }}>
                    {parseFloat(item.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                  <td style={{ fontSize: 14 }}>{item.remark}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>

    </>
  )}
</div>
</div>



              </div>
       




          {savingsLoading && (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          )}

        </div>
        )
}
        export default ReconSummaryReport;


        {/* <div style={{ marginTop: 27 }} /> */}
        {/* {accounts?.length > 0 && (
        <div className={classes.cardContainer}>
  {(() => {
    const openingBalance = parseFloat(accounts[0]?.opening_balance || 0);

  
    let totalDebit = 0;
    let totalCredit = 0;

    accounts.forEach((item) => {
      totalDebit += parseFloat(item.debit) || 0;
      totalCredit += parseFloat(item.credit) || 0;
    });

    const closingBalance = parseFloat(accounts[0]?.closing_balance || 0);

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        labelColor: "#2563EB",
      },
      
      {
        label: "Total Debits",
        value: totalDebit,
        labelColor: "#EF4444",
      },
      {
        label: "Total Credits",
        value: totalCredit,
        labelColor: "#16A34A",
      },
      {
        label: "Closing Balance",
        value: closingBalance,
        labelColor: "#A855F7",
      },
    ];

    return stats.map((item, idx) => (
      <div className={classes.statCard} key={idx}>
       
        <h3 className={classes.cardValue}>
          <span style={{ color: item.labelColor }}>
            {item.value.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </h3>

       
        <div className={classes.cardHeader}>
          <p className={classes.cardLabel}  style={{ color: item.labelColor }}>{item.label}</p>
        </div>
      </div>
    ));
  })()}
</div>
)} */}
